import { generateJoiValidation } from '@/shared/utils';
import Joi from 'joi';
import { PartnerNetwork } from './partnerNetwork.model';
import { objectId } from '@/shared/validations/custom.validation';


export const getPartnerNetwork = {

  query: Joi.object().keys({
    type: Joi.string(),
    name: Joi.string(),
    sortBy: Joi.string(),
    search: Joi.string(),
    limit: Joi.number().integer().min(1),
    page: Joi.number().integer().min(-1),
    includeTimeStamps: Joi.boolean(),
  }),
};


export const connectPartnerNetwork = () => ({
  body: generateJoiValidation(PartnerNetwork.schema),
});

export const deletePartnerNetworkById = {
  params: Joi.object().keys({
    id: Joi.string().custom(objectId),
  }),
};



